// Tiny canvas-free confetti (no deps). Spawns ephemeral colored dots that
// fall with a bit of drift and fade out — celebrates PDF generation.
export function fireConfetti({ duration = 1600, count = 60 } = {}) {
  const root = document.createElement("div");
  root.style.cssText = "position:fixed;inset:0;pointer-events:none;overflow:hidden;z-index:9999";
  document.body.appendChild(root);
  const colors = ["#0A3D79", "#a07a27", "#c05746", "#3a5b4d", "#1FA0E6", "#e2b6a9", "#E7F1FB"];
  for (let i = 0; i < count; i++) {
    const d = document.createElement("div");
    const size = 6 + Math.random() * 8;
    d.style.cssText = [
      "position:absolute",
      `top:-20px`,
      `left:${Math.random() * 100}vw`,
      `width:${size}px`,
      `height:${size * (0.6 + Math.random() * 0.9)}px`,
      `background:${colors[i % colors.length]}`,
      `border-radius:${Math.random() > 0.5 ? "2px" : "50%"}`,
      `transform:rotate(${Math.random() * 360}deg)`,
      `opacity:0.92`,
      `transition:transform ${duration}ms ease-out, top ${duration}ms cubic-bezier(0.2,0.7,0.3,1), opacity ${duration}ms ease-out`,
    ].join(";");
    root.appendChild(d);
    // Kick animation next frame.
    requestAnimationFrame(() => {
      d.style.top = `${70 + Math.random() * 30}vh`;
      d.style.transform += ` translateX(${-40 + Math.random() * 80}px) rotate(${360 + Math.random() * 360}deg)`;
      d.style.opacity = "0";
    });
  }
  setTimeout(() => root.remove(), duration + 200);
}
